/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionSchedule } from './EmployeeExecutionSchedule';
/**
 * CRM task creation operation executed by the native runtime.
 */
export type EmployeeExecutionTaskCreateOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionTaskCreateOperation.kind;
    /**
     * Self-contained task condition and action.
     */
    description: string;
    /**
     * Structured schedule resolved from the workflow instruction.
     */
    schedule: EmployeeExecutionSchedule;
};
export namespace EmployeeExecutionTaskCreateOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        TASK_CREATE = 'task-create',
    }
}

